import { Button, Flex, Text, Tooltip, useMantineTheme } from "@mantine/core";
import { InfoCircle } from "iconsax-react";
import { useTranslation } from "react-i18next";

interface IProps {
  isLoadingDownload: boolean;
  disabledExportTable: boolean;
  onClick: () => void;
  days: number;
}
export default function ButtonExport({
  isLoadingDownload,
  disabledExportTable,
  onClick,
  days,
}: IProps) {
  const theme = useMantineTheme();
  const { t } = useTranslation();

  return (
    <Flex w="100%" maw={{ base: "100%", 780: "180px" }} pos="relative">
      {disabledExportTable ? (
        <Tooltip
          maw={"280px"}
          w="100%"
          multiline
          withArrow
          position="top"
          label={
            <Text size="sm" color="white">
              <b>{t("operacoes.button_export.tooltip_1")}</b>{" "}
              {t("operacoes.button_export.tooltip_2", { days: days })}
            </Text>
          }
        >
          <span
            style={{
              width: "fit-content",
              position: "absolute",
              top: "-10px",
              right: "-10px",
              zIndex: 1,
            }}
          >
            <InfoCircle
              size="20"
              color={theme.colors.alerts[0]}
              variant="Bold"
            />
          </span>
        </Tooltip>
      ) : null}
      <Button
        variant="primaryOutline"
        w="100%"
        maw={{ base: "100%", 780: "180px" }}
        onClick={onClick}
        loading={isLoadingDownload}
        loaderProps={{ color: theme.colors.primary[1] }}
        disabled={disabledExportTable}
      >
        {isLoadingDownload
          ? t("operacoes.button_export.button_loading")
          : t("operacoes.button_export.button")}
      </Button>
    </Flex>
  );
}
